import { Game } from './core/Game';

const canvas = document.getElementById('scene');
if (!(canvas instanceof HTMLCanvasElement)) {
  throw new Error('<canvas id="scene"> introuvable');
}

const game = new Game(canvas);

game.init().catch((err: unknown) => {
  console.error(err);
  const text = document.getElementById('loading-text');
  if (text) {
    text.textContent =
      err instanceof Error ? `Échec du chargement : ${err.message}` : 'Échec du chargement.';
  }
});
